<div class="timHeader">
  <div style="width: 11.5%">
    <img
      src="assets/duke-logo.svg"
      (click)="goToDashboard()"
      class="dukeLogo"
      style="cursor: pointer"
    />
  </div>
  <div style="width: 2%">
    <img src="assets/vertical-line.svg" />
  </div>
  <div style="width: 5%">
    <img
      src="assets/mmaps-logo-nav.svg"
      (click)="goToDashboard()"
      class="mmapsLogo"
      style="cursor: pointer"
    />
  </div>
  <div
    style="
      display: flex;
      gap: 4%;
      justify-content: end;
      flex: auto;
      padding-right: 3%;
    "
  >
    <span
      class="headerOptionText"
      style="cursor: pointer; visibility: hidden"
      (click)="openProjectSetups()"
      >My Project Setups</span
    >

    <div
      (click)="createNewForm()"
      style="display: flex; gap: 5px; cursor: pointer"
    >
      <img
        src="assets/note_add.svg"
        style="height: 20px; width: 20px; position: relative; top: 2px"
      />
      <span class="headerOptionText underline">Create New Form</span>
    </div>

    <!-- Form Dashboard - 3-state navigation based on access -->
    <!-- Case 1: User has access to multiple dashboards - show menu dropdown -->
    <div
      *ngIf="(hasETSAccess() || hasRealEstateAccess()) && getDashboardAccessCount() > 1"
      style="display: flex; gap: 5px; cursor: pointer"
      [matMenuTriggerFor]="menu"
    >
      <img
        src="assets/team_dashboard.svg"
        style="height: 20px; width: 20px; position: relative; top: 2px"
      />
      <span class="headerOptionText underline" 
        >Form Dashboard</span
      >
      <mat-menu #menu="matMenu">
        <button *ngIf="hasETSAccess()" mat-menu-item (click)="formDashboard('IT_SPAR_DASHBOARD')">MMARF Dashboard</button>
        <button *ngIf="hasRealEstateAccess()" mat-menu-item (click)="formDashboard('REAL_ESTATE_DASHBOARD')">Real Estate Dashboard</button>
      </mat-menu>
    </div>

    <!-- Case 2: User has access to only one dashboard - direct link -->
    <div
      *ngIf="(hasETSAccess() || hasRealEstateAccess()) && getDashboardAccessCount() === 1"
      style="display: flex; gap: 5px; cursor: pointer"
      (click)="navigateToSingleDashboard()"
    >
      <img
        src="assets/team_dashboard.svg"
        style="height: 20px; width: 20px; position: relative; top: 2px"
      />
      <span class="headerOptionText underline" 
        >Form Dashboard</span
      >
    </div>

    <div
      *ngIf="hasLegacySPARAccess()"
      style="display: flex; gap: 5px; cursor: pointer"
      (click)="goToLegacyForm()"
    >
      <img
        src="assets/document.svg"
        style="height: 16px; width: 16px; position: relative; top: 4px"
        class="svg-white"
      />
      <span class="headerOptionText underline">Modify a Legacy SPAR</span>
    </div>
    <!-- Case 3: User has no dashboard access - hidden (no div shown) -->

    <div style="display: flex; gap: 5px; cursor: pointer">
      <img
        src="assets/nam-id-white.svg"
        style="height: 16px; width: 16px; position: relative; top: 4px"
      />
      <span class="headerOptionText">{{ userName }}</span>
    </div>
  </div>
</div>
